import { Injectable } from "@angular/core";
import { SendTransaction } from "@models/transaction";
import { Observable } from "rxjs";
import { Fee } from "@modules/main/components/step-summary/sending-modal/entities/fee.model";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { filter, map } from "rxjs/operators";
import { Price } from "@models";
import { WalletsBalancesApiResponse } from "@modules/+new/core/wallets-balances/domain/entities/wallets-balances-response.api.model";
import { parseApiResponseObject } from "@helpers/functions";

@Injectable({ providedIn: "root" })
export class SendingModalRemoteService {
	constructor(private apicallService: ApicallService) {}

	public getFeeForTransaction(transaction: SendTransaction, walletId: string): Observable<Fee> {
		return this.apicallService
			.post("wallet/" + walletId + "/send/validate", new ApicallOption(Fee, transaction))
			.pipe(
				map((fees: Fee[]) => fees[0]),
				filter((fee) => !!fee)
			);
	}

	public fetchPriceLimits(sendType: string, walletId: string, coin_network_id?: string): Observable<Price> {
		return this.apicallService
			.post("wallet/" + walletId + "/limits", new ApicallOption(Price, { type: sendType, coin_network_id }))
			.pipe(map((prices) => prices[0]));
	}

	public getBalance$(): Observable<WalletsBalancesApiResponse> {
		return this.apicallService
			.get("user/balances")
			.pipe(map((val) => parseApiResponseObject<WalletsBalancesApiResponse>(val)));
	}
}
